<span
	*ngIf="isRenderable && id"
	class="badge rounded-pill px-3 py-2 fs-md fw-regular chipItem-wrapper fade"
	[ngClass]="{
		'disabled': isDisabled,
		'd-none': isHidden,
		'active': isSelected,
		'show cursor-pointer': name,
		'pe-none': !name
	}"
	(click)="onClick()"
>
	<!-- Icon Todo can be extended later -->

	<!-- Name -->
	<span
		*ngIf="name"
		class="chipItem-name fade"
		[ngClass]="{
			'show': name
		}"
	>
		{{ name }}
	</span>
</span>
